import { createSlice } from "@reduxjs/toolkit";

const movimentoSlice = createSlice({
    name: 'movimento',
    initialState: {
        movimento: {},
        duplicata: []
    },
    reducers: {
        addMovimento: (state, action) => {
            state.movimento = action.payload
        },
        addDuplicata: (state, action) => {
            state.duplicata = action.payload
        }
    },
});

export const { addMovimento, addDuplicata } = movimentoSlice.actions;
export default movimentoSlice.reducer;